import { compact } from "lodash";
import * as React from "react";
import styled from "styled-components/native";

import { AppContextRole } from "../types";
import Button from "../components/common/PressableButton";
import ToggleInput from "../components/common/ToggleInput";
import useFetchCurrentUser from "../hooks/useFetchCurrentUser";
import { Info, Label, LayoutColumn, Space, spacing } from "../styled-component";

import useAppContextRole from "./useAppContextRole";
import Layout from "../components/common/Layout";

export interface AppContextSwitcherProps {
  onPress?: () => void;
}

function AppContextSwitcher({ onPress }: AppContextSwitcherProps) {
  const [role, setRole] = useAppContextRole();
  const { data: currentUser } = useFetchCurrentUser();
  const { superuser } = currentUser || {};
  const typeOptions = React.useMemo<AppContextRole[]>(
    () =>
      compact([
        AppContextRole.Instructor,
        AppContextRole.Learner,
        superuser ? AppContextRole.Admin : undefined,
      ]),
    [superuser]
  );

  return (
    <Layout.Column>
      <Label>Role</Label>

      <ToggleInput
        value={role}
        options={typeOptions}
        onChange={(option) => {
          setRole(option as AppContextRole);
          // onPress?.();
        }}
      />
    </Layout.Column>
  );
}

export default AppContextSwitcher;
